const footer = {
  ConnectWithUs: "Connect with us!",
  Copyright: `Copyright © 1997-{{ currentYear }} Emerson Ecologics, LLC, All rights reserved.`,
  ProductInfoDisclaimer: `We work to ensure that product information is correct; however, brands may make changes to
    product from time to time, and actual product packaging and materials may contain more
    and/or different information than that shown on our website. Please consult all labels,
    warnings, and directions prior to using or consuming products for the most accurate
    product information.`,
} as const;

export { footer };
